<template>
  <router-link
    class="country-link"
    :to="`/name/${country.name}`"
  >
    <div
      class="country-card"
    >
      <div
        class="country-card-flag"
      >
        <img
          :src="country.flag"
          :alt="`${country.name}'s Flag`"
        >
      </div>

      <div
        class="country-card-details"
      >
        <h3>{{ country.name }}</h3>
        <p><b>Population: </b>{{ country.population.toLocaleString() }}</p>
        <p><b>Region: </b>{{ country.region }}</p>
        <p><b>Capital: </b>{{ country.capital }}</p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    country: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="sass">
.country-link
  text-decoration: none
.country-card
  width: 16.5rem
  min-height: 21rem
  background-color: var(--clr-ui-elements)
  overflow: hidden
  border-radius: .35em
  box-shadow: 0 0 .6em rgba(0, 0, 0, .15)

  &-flag
    width: 100%
    max-height: 12rem
    overflow: hidden
    > *
      width: 100%
      height: 100%
      object-fit: contain

.country-card-details
  padding: 1em 1.5em
  > h3
    font-weight: 800
    font-size: 1.125rem
    color: var(--clr-text)
    letter-spacing: -0.7%
    margin-bottom: .55em
    @media (min-width: 37.5em)
      letter-spacing: -1.5%

  > p
    font-weight: 300
    font-size: .875rem
    color: var(--clr-text)
    b
      font-weight: 600

</style>
